import React from 'react';

const MLAppStateContext = React.createContext({
    appState: {},
    setAppState: () => {}
});

const MLAppStateReducer = function(state, payload){
    let hasChanged = false;
    const newState = {...state};

    if(state.quoteID !== payload.quoteID){
        hasChanged = true;
        newState.quoteID = payload.quoteID;
    }
    if(state.sessionUUID !== payload.sessionUUID){
        hasChanged = true;
        newState.sessionUUID = payload.sessionUUID;
    }
    if(state.emailAddress1 !== payload.emailAddress1){
        hasChanged = true;
        newState.emailAddress1 = payload.emailAddress1;
    }
    if(state.phoneNumber !== payload.phoneNumber){
        hasChanged = true;
        newState.phoneNumber = payload.phoneNumber;
    }
    if(state.submissionStatus !== payload.submissionStatus){
        hasChanged = true;
        newState.submissionStatus = payload.submissionStatus;
    }
    if(state.policyNumber !== payload.policyNumber){
        hasChanged = true;
        newState.policyNumber = payload.policyNumber;
    }
    if(hasChanged){
        return newState;
    }
    return state;
}

export {
    MLAppStateContext,
    MLAppStateReducer
};
